import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {SessionStorageService} from 'ngx-webstorage';
import {AbstractSubscribeUnsubscribeDirective} from '@supoui/shared/components/abstract-subscribe-unsubscribe-directive';
import {LANGUAGES} from '@supoui/core/language/language.constants';
import {AccountService} from '@supoui/core/auth/account.service';
import {ProfileService} from '../../layouts/profiles/profile.service';
import {UserService} from '@supoui/core/user/user.service';
import {Account} from '@supoui/core/user/account.model';
import {UntilDestroy} from '@ngneat/until-destroy';
import {DisplayPageType, PageType} from '@supoui/shared/components/info-bar/info-bar.component';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from "@supoui/core/auth/authentication.service";
import {ChangePasswordModalComponent} from "@supoui/shared/components/change-password-modal/change-password-modal.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'jhi-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['navbar.scss'],
    standalone: false
})
@UntilDestroy({ checkProperties: true })
export class NavbarComponent extends AbstractSubscribeUnsubscribeDirective implements OnInit {
  inProduction?: boolean;
  isNavbarCollapsed = true;
  languages = LANGUAGES;
  swaggerEnabled?: boolean;
  version: string;

  account: Account;

  avatarUrl: string | null;

  constructor(
    private authenticationService: AuthenticationService,
    private translateService: TranslateService,
    private sessionStorage: SessionStorageService,
    private accountService: AccountService,
    private userService: UserService,
    private profileService: ProfileService,
    public router: Router,
    private modalService: NgbModal
  ) {
    super();
//    this.version = VERSION ? (VERSION.toLowerCase().startsWith('v') ? VERSION : 'v' + VERSION) : '';
  }

  ngOnInit(): void {
    this.profileService.getProfileInfo().subscribe(profileInfo => {
      this.inProduction = profileInfo.inProduction;
      this.swaggerEnabled = profileInfo.swaggerEnabled;
    });
    this.subscriptions.push(
      this.accountService.identity().subscribe(account => (account ? (this.account = account) : null)),
      this.userService.avatarImageChanged$.subscribe(changed => {
        this.getAvatarUrl(changed);
      })
    );
  }

  changeLanguage(languageKey: string): void {
    this.sessionStorage.store('locale', languageKey);
    this.translateService.use(languageKey);
    if (this.account) {
      this.account.langKey = languageKey;
      const subscription: Subscription = this.accountService.save(this.account).subscribe(() => {
        this.accountService.languageChanged(languageKey);
        subscription.unsubscribe();
      });
    }
  }

  collapseNavbar(): void {
    this.isNavbarCollapsed = true;
  }

  isAuthenticated(): boolean {
    return this.accountService.isAuthenticated();
  }

  logout(): void {
    this.collapseNavbar();
    this.sessionStorage.clear(DisplayPageType.DISPLAY_LAST_PAGE);
    this.sessionStorage.clear(DisplayPageType.DISPLAY_FRONT_PAGE);
    this.sessionStorage.clear(PageType.FRONT_PAGE);
    this.sessionStorage.clear(PageType.LAST_PAGE);
    this.subscriptions.push(this.authenticationService.logout().subscribe());
  }

  toggleNavbar(): void {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }

  getLogin(): string {
    if (!this.isAuthenticated()) {
      return '';
    } else {
      return this.accountService.getLogin();
    }
  }

  getAvatarUrl(forceRefresh = false): void {
    this.avatarUrl = this.isAuthenticated() ? this.userService.avatarUrl(this.accountService.getLogin(), forceRefresh) : '';
  }

  getImageUrl(): string {
    return this.isAuthenticated() ? this.accountService.getImageUrl() : '';
  }

  changePassword(): void {
    this.modalService.open(ChangePasswordModalComponent, {size: 'lg', centered: true});
  }
}
